













import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class PlanningModalityCharts extends BaseComponent {
  @Prop()
  kpis: any;

  @Prop()
  planning: boolean;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    width: 250,
    height: 70,
    chartArea: { width: '100%', height: '100%' },
    legend: { position: 'labeled', text: 'value', textStyle: { color: 'black' } },
    fontSize: 12,
    pieSliceText: 'none',
    tooltip: { trigger: 'none' },
    slices: [{ color: '102D69' }, { color: 'F5B830' }]
  };

  mounted() {}

  load() {
    this.chartData = [];
    if (!this.kpis.planejadas && !this.kpis.naoPlanejadas && !this.kpis.presenciais && !this.kpis.naoPresenciais) {
      return;
    }
    if (this.planning) {
      this.chartData.push(['Tipo', 'Quantidade']);
      this.chartData.push(['Planejada', this.kpis.planejadas]);
      this.chartData.push(['Não planejada', this.kpis.naoPlanejadas]);
    } else {
      this.chartData.push(['Tipo', 'Quantidade']);
      this.chartData.push(['Presencial', this.kpis.presenciais]);
      this.chartData.push(['Online', this.kpis.naoPresenciais]);
    }
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }
}
